import { Record as record } from 'immutable';

import { construct, resolve } from '../../helpers/LinkMapper';
import Trip from '../order/Trip';
import { getOrderedPassengerTickets } from '../../utils/splits';

const defaults = {
    amendedTicket: null,
    newTicket: null,
    amended: false,
    amendedTrip: null
};

class AmendedTicket extends record(defaults) {
    // Keyed by ticket instance rather than field values: amendedTrip/amendedTicket never change for
    // a given (immutable) instance, so the lookup is safe to cache for the instance's lifetime —
    // avoids re-scanning the historical trip's fares when getPassengerIndex() and getOldFare() are
    // both called for the same ticket, as Order.js's split-passenger grouping does.
    static #oldFareCache = new WeakMap();

    static fromJSON (json) {
        return construct(AmendedTicket, json, {
            amendedTicket: json.amendedTicket,
            newTicket: json.newTicket,
            amended: json.amended,
            amendedTrip: resolve(json.amendedTrip).as(Trip)
        });
    }

    isNewTicket (id) {
        return this.newTicket === id;
    }

    getOldFare () {
        if (!AmendedTicket.#oldFareCache.has(this)) {
            AmendedTicket.#oldFareCache.set(this, this.amendedTrip.getFareByTicketId(this.amendedTicket));
        }
        return AmendedTicket.#oldFareCache.get(this);
    }

    // Uses the same canonical ordering as the new/current side's passenger grouping
    // (getOrderedPassengerTickets, src/utils/splits.js) rather than raw array position, so old
    // and new tickets pair up by the same passenger convention on both sides of an amend.
    getPassengerIndex () {
        const fare = this.getOldFare();
        return fare ? getOrderedPassengerTickets(fare).findIndex(ticket => ticket.id === this.amendedTicket) : -1;
    }
}

export default AmendedTicket;
